// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3d38bddc].v-chip.tag {\n  border-radius: 18px;\n  height: 27px;\n  font-size: 12px;\n}\n[data-v-3d38bddc].v-chip.tag.small {\n  height: 20px;\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
